import React from "react";
import { toast } from "react-toastify";
import { postRightworkAPI } from "../requests/utilities/requests";
import { API_post_set_direct_assignability } from "../../../constants";
import SettingToggleCard from "./SettingToggleCard";

const DESCRIPTION =
  "Lets you assign this on its own from Training Overview, without adding it to a track.";

/**
 * Persist a "make directly assignable" change. Called by an editor's Save
 * handler — like any other setting, this only runs on Save, never on toggle.
 * The asset must already have a uuid (saved). Error-toasts on failure; silent
 * on success since the editor shows its own "Saved" toast.
 *
 * Returns true on success / no-op.
 */
export async function setDirectAssignability({
  companyId,
  assetType,
  assetUuid,
  isAssignable,
}) {
  if (!assetUuid) return false;
  try {
    await postRightworkAPI(API_post_set_direct_assignability, {
      company_id: companyId,
      asset_type: assetType,
      asset_uuid: assetUuid,
      is_assignable: isAssignable,
    });
    return true;
  } catch (error) {
    const message = error?.response?.data?.system?.message;
    toast.error(message || "Saved, but could not update assignability.", {
      autoClose: 4000,
    });
    return false;
  }
}

/**
 * Presentational checkbox (shared card style). It is part of the editor's form
 * state and is persisted on Save (it never calls the API itself) — exactly like
 * the other settings in the editor.
 *
 * Props:
 *  - value: boolean
 *  - onChange: (newValue: boolean) => void
 */
function DirectAssignabilityToggle({ value, onChange }) {
  return (
    <SettingToggleCard
      checked={value}
      onChange={onChange}
      title="Make directly assignable"
      description={DESCRIPTION}
    />
  );
}

export default DirectAssignabilityToggle;
